import * as _ from 'lodash';

export function uniqueWith<T>(array: T[], comparator: (arrVal: T, othVal: T) => boolean) {
    return _.uniqWith(array, comparator);
}
